import React, { useState, useEffect, useMemo, useCallback } from 'react';
import apis from '@/pages/mvp-panel/participant-data/apis.js';
import {  message, Empty } from '@drip/drip-design';
// @ts-ignore
import { Table, TableFormatterName, TableFormatterOperation, TableFormatterRank, TableFormatterRatioBar, TableFormatterTag, TableFormatterCurrency, TableFormatterInteger, Tag, Loading, Drawer, DrawerSection, Label, Form, FormItem, Space, RadioGroup, Cascader, Select, Icon, Button, Alert } from '@jd/jmtd';
// @ts-ignore
import { format } from '@jd/jmtd-tools/es/number';
import { getJmtdValFormatter } from '@/pages/mvp-panel/participant-data/components/global-effect/config';
import _ from 'lodash';
// @ts-ignore
import { formatDate } from '@jd/jmtd-tools/es/date';
import './index.less';

const modelId_1_SKU = '98d727b7-105c-4f69-a60c-c1b337b9ded6'; //SKU一级列表(页面初始化及未点击任何下钻情况使用):
const modelId_1_SPU = '99e7e57e-c8ac-4917-9566-182aee0a898e'; //SPU一级列表
const modelId = '6176c891-812a-49bc-b001-864a3511737c' //子表格

const mapData = {
  'ge_deal_standard_deal_ord_amt':'flow_source_to_item_deal_ord_amt',
  'flow_item_detail_view_uv': 'flow_source_to_item_uv',
  'ge_deal_standard_deal_sub_ord_qtty': 'flow_source_to_item_detail_deal_sub_ord_qtty'
}
const indexData = [
  {
    value: 'flow_source_to_item_deal_ord_amt',
    label: '成交金额'
  },

  {
    value: 'flow_source_to_item_uv',
    label: '商详访问UV'
  },

  {
    value: 'flow_source_to_item_detail_deal_sub_ord_qtty',
    label: '成交子单量'
  }
];

const indexObj = new Map([
  ['flow_source_to_item_deal_ord_amt',{
    name: '成交金额',
    showName: '金额',
    type: 0, //1 增长,0保持, -1下降,
    valueType: 5,
    value: 0,
    ratio: 0,
    key: 'ge_deal_standard_deal_ord_amt'
  }],
  ['flow_source_to_item_uv',{
    name: '商详UV',
    showName: 'UV',
    type: 0, //1 增长,0保持, -1下降
    valueType: 1,
    value: 0,
    ratio: 0,
    key: 'flow_item_detail_view_uv'
  }],
  ['flow_source_to_item_detail_deal_sub_ord_qtty',{
    name: '成交子单量',
    showName: '子单量',
    type: 0, //1 增长,0保持, -1下降
    valueType: 1,
    value: 0,
    ratio: 0,
    key: 'ge_deal_standard_deal_sub_ord_qtty'
}]
])
// @ts-ignore
function findPlaceName(tree: any, key: any){
  for(const data of tree){
    if(data.dimFullCode == key){
      return data.name
    }
    if(data.children && data.children.length > 0){
      // @ts-ignore
      const res = findPlaceName(data.children, key)
      if(res){
        return res
      }
    }
  }
  return null
}

function DrawerTable(props: any) {
  const { conditions, visible, drawerItem, tableQuery, placeList, planList, selObj, selPlaceList} = props;
  const { beginDate, endDate, cBeginDate, cEndDate } = conditions;

  const [placeName, setPlaceName] = useState('');
  const [tableData, setTableData] = useState({
    bos: [],
    total: 0,
    loading: false
  });

  const [subTableData, setSubTableData] = useState({
    bos: [],
    total: 0,
    loading: false
  });

  const [showMore, setShowMore] = useState(false);

  const dftPagination = {
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: false
  };

  const [pagination, setPagination] = useState(dftPagination);

  //主表格数据
  const [handledDataSource, setDataSource] = useState<any>([]);
  //副表格数据
  const [subDataSource, setSubDateSource] = useState<any>([]);

  const [drawerVisible, setDrawerVisible] = useState(false);

  // @ts-ignore
  const [indexValue, setIndexValue] = useState(mapData[props.sortField]);
  // const [selItem, setSelItem] = useState(indexObj.get(indexData[0].value))
  const [allItem, setAllItem] = useState<any>(null)
  const [topSku, setTopSku] = useState({
    value: 0,
    loading: false
  });
  const [channel, setChannel] = useState([]);
  const [selChannel, setSelChannel] = useState();

  let tips = window.localStorage.getItem(`__${props.erp}__handleClickTips__`);
  const [closedTips, setIsShowTips] = useState(tips == 'true');

  useEffect(() => {
    setDrawerVisible(visible);
    setShowMore(false)
  }, [visible]);

  useEffect(() => {
    const placeId = selPlaceList?.length > 0 ?selPlaceList.join('/') : ''
    const name = findPlaceName(placeList, placeId);
    if(name){
      setPlaceName(name)
    }else{
      setPlaceName('全部')
    }
  }, [selPlaceList]);

  // 查询sku在大盘中的排名信息
  useEffect(() => {
    if(!visible || _.isEmpty(allItem)) return;
    setTopSku((val) => Object.assign({}, val, { loading: true, value: '?' }));
    const p = _.cloneDeep(tableQuery);
    const item = allItem.get(indexValue);
    let skuId = '';
    if (p.itemType == '2') {
      p.topSku = drawerItem.spu_id;
      p.modelId = modelId_1_SPU;
      skuId = drawerItem.spu_id;
    } else {
      p.topSku = drawerItem.sku_id
      p.modelId = modelId_1_SKU;
      skuId = drawerItem.sku_id;
    }
    p.diaIndex = item.key;
    p.trend = item?.type === 1 ? 1 : -1;
    p.indicators = [
      "flow_item_detail_view_uv",
      "ge_deal_standard_deal_ord_amt",
      "ge_deal_standard_deal_sub_ord_qtty"
    ]; //诊断固定查三个指标

    //重置继承的分页
    p.pageNo = 1;
    p.pageSize = 10;


    apis.querySkuDiagnoseInfo(p)
      .then((res) => {
        const { ret, msg, data } = res;
        if (ret !== '0' || !data) throw msg || '表格接口请求失败';
        const result = {
          value: data[skuId]
        }
        setTopSku(Object.assign({}, result, { loading: false}));
    })
      .catch((ex) => {
        message.error(ex);
        setTopSku((val) => Object.assign({}, val, { loading: false, value: '?'}));
      });
  }, [allItem, visible, indexValue]);

  //查询sku渠道
  useEffect(() => {
    if(!visible) return;
    setChannel([]);
    // @ts-ignore
    setSelChannel('');

    const p = _.cloneDeep(tableQuery);
    if (p.itemType == '2') {
      p.skuId = drawerItem.spu_id;
      p.modelId = modelId_1_SPU;
    } else {
      p.skuId = drawerItem.sku_id
      p.modelId = modelId_1_SKU;
    }

    //重置继承的分页
    p.pageNo = 1;
    p.pageSize = 10;


    apis.queryLastChannelInfo(p)
      .then((res) => {
        const { ret, msg, data } = res;
        if (ret !== '0' || !data) throw msg || '表格接口请求失败';
        const bos = data.bos ?? []
        // data.bos = data?.bos?.map((item:any)=>({...item,hasChildren:true}))
        // 转化数据就是 name->label code->value
        const dataStr = JSON.stringify(bos)
          .replace(/value/g, 'label')
          .replace(/key/g, 'value');
        const formatList:any = JSON.parse(dataStr);
        setChannel(formatList)
      })
      .catch((ex) => {
        message.error(ex);
      });
  }, [props.tableQuery, visible, indexValue]);

  //查询sku渠道诊断列表
  useEffect(() => {
    if(!visible || _.isEmpty(allItem)) return;
    setSubTableData((val) => Object.assign({}, val, { loading: true }));
    // setSubDateSource([]);
    const p = _.cloneDeep(tableQuery);
    const { criteria } = p;
    if (p.itemType == '2') {
      p.modelId = modelId;
      p.criteria = {
        ...criteria,
        spu_id: [drawerItem.spu_id]
      }
    } else {
      p.modelId = modelId;
      p.criteria = {
        ...criteria,
        sku_id: [drawerItem.sku_id]
      }
    }
    if(Array.isArray(selChannel)) {
      // @ts-ignore
      if (selChannel?.length === 1) {
        p.criteria.last_src_channel_id_1 = selChannel[0]
      } else { // @ts-ignore
        if (selChannel?.length === 2) {
                p.criteria.last_src_channel_id_2 = selChannel[1]
              }
      }
    }
    p.indicators = [
      "flow_source_to_item_deal_ord_amt",
      "flow_source_to_item_detail_deal_sub_ord_qtty",
      "flow_source_to_item_uv"
    ]; //诊断固定查三个指标
    const item = allItem.get(indexValue);
    p.diaIndex = indexValue;
    p.trend = item?.type === 1 ? 1 : -1;

    //重置继承的分页 和接口约定，pageSize = 1000
    p.pageNo = 1;
    p.pageSize = 1000;

    apis.queryDiagnoseTotalList(p)
      .then((res) => {
        const { ret, msg, data } = res;
        if (ret !== '0' || !data) throw msg || '表格接口请求失败';
        const bos = data.bos;
        // let  result = [];
        // result = bos?.map((item:any)=>{
        //   return {
        //     ...item,
        //     flow_source_to_item_uv_prct: item.flow_source_to_item_uv ? item.flow_source_to_item_uv_com/item.flow_source_to_item_uv : null,
        //     flow_source_to_item_deal_ord_amt_prct: item.flow_source_to_item_deal_ord_amt ?  item.flow_source_to_item_deal_ord_amt_com/item.flow_source_to_item_deal_ord_amt : null,
        //     flow_source_to_item_detail_deal_sub_ord_qtty_prct: item.flow_source_to_item_detail_deal_sub_ord_qtty ? item.flow_source_to_item_detail_deal_sub_ord_qtty_com/item.flow_source_to_item_detail_deal_sub_ord_qtty : null
        //   }
        // })
        setSubDateSource(bos)
        setSubTableData(Object.assign({}, data, { loading: false }));

      })
      .catch((ex) => {
        message.error(ex);
        setSubTableData((val) => Object.assign({}, val, { loading: false }));
        setSubDateSource([]);
      });
  }, [indexValue, visible, allItem, selChannel]);

  // 查询一级表格
  useEffect(() => {
    if (!tableQuery.indicators || !tableQuery.userType || !visible) return;
    let didMount = true;
    setTableData((val) => Object.assign({}, val, { loading: true }));
    //重置指标
    // @ts-ignore
    setIndexValue(mapData[props.sortField])
    setAllItem(null)
    const _tableQuery = _.cloneDeep(tableQuery);
    const { criteria } = _tableQuery;
    if (_tableQuery.itemType == '2') {
      // 根据sku和spu选择modelId
      _tableQuery.modelId = modelId_1_SPU;
      _tableQuery.criteria = {
        ...criteria,
        spu_id: [drawerItem.spu_id]
      }
    } else {
      _tableQuery.modelId = modelId_1_SKU;
      _tableQuery.criteria = {
        ...criteria,
        sku_id: [drawerItem.sku_id]
      }
    }
    _tableQuery.indicators = [
      "flow_item_detail_view_uv",
      "ge_deal_standard_deal_ord_amt",
      "ge_deal_standard_deal_sub_ord_qtty"
    ]; //诊断固定查三个指标

    //重置继承的分页
    _tableQuery.pageNo = 1;
    _tableQuery.pageSize = 10;

    apis
      .queryGoodsAnalysis(_tableQuery)
      .then((res) => {
        if (!didMount) return;
        const { ret, msg, data } = res;
        if (ret !== '0' || !data) throw msg || '表格接口请求失败';
        // data.bos = data?.bos?.map((item:any)=>({...item,hasChildren:true}))
        const bos = data.bos?.[0] ?? {}
        setDataSource(data.bos);
        const map = new Map();
        const list = [
          "flow_source_to_item_uv",
          "flow_source_to_item_deal_ord_amt",
          "flow_source_to_item_detail_deal_sub_ord_qtty"
        ].map(key=>{
          const result = indexObj.get(key);
          const itemKey = result?.key;
          const ratio = bos[`${itemKey}_ratio`];
          const value = bos[`${itemKey}`];
          const diff = Math.abs(bos[`${itemKey}`] - bos[`${itemKey}_com`]);
          map.set(key, {
            ...result,
            type : ratio > 0 ? 1 : ratio < 0 ? -1 : ratio == 0 ? 0 : null,
            ratio,
            value,
            diff
          })
          return {
            ...result,
            type : ratio > 0 ? 1 : ratio < 0 ? -1 : ratio == 0 ? 0 : null,
            ratio,
            value,
            diff
          }
        })
        setAllItem(map)
        setPagination({
          ...pagination,
          total: data.total
        });
        setTableData(Object.assign({}, data, { loading: false }));
      })
      .catch((ex) => {
        message.error(ex);
        setTableData((val) => Object.assign({}, val, { loading: false }));
      });
    return () => {
      didMount = false;
    };
  }, [props.tableQuery, visible]);


  const getColumns= useMemo(()=>{
    const { itemType, indicators } = conditions;
    const keyVal: { [key: string]: any } = {
      '1': { imgUrl: 'sku_img_url', name: 'sku_name', id: 'sku_id', key: 'SKU' },
      '2': { imgUrl: 'spu_img_url', name: 'spu_name', id: 'spu_id', key: 'SPU' }
    };
    let _columns = []
    _columns.push({
      dataIndex: `${keyVal[itemType].name}`,
      title: '商品信息',
      imgIndex: `${keyVal[itemType].imgUrl}`,
      idIndex: `${keyVal[itemType].id}`,
      idLabel: `${keyVal[itemType].key}`,
      formatter: TableFormatterName,
      affix: true,
    });

    _columns.push({
      title: '成交金额',
      dataIndex: 'ge_deal_standard_deal_ord_amt',
      render: (text: any) => {
        return (<Space>
          <span>成交金额</span>
          <span>{format(text, 'currency_¥')}</span>
        </Space>)
      },
      // formatter: TableFormatterCurrency,
    });
    _columns.push( {
      title: '较对比日',
      dataIndex: 'ge_deal_standard_deal_ord_amt' + '_ratio',
      formatter: TableFormatterTag,
    });

    _columns.push({
      title: '商详访问UV',
      dataIndex: 'flow_item_detail_view_uv',
      render: (text: any) => {
        return (<Space>
          <span>商详访问UV</span>
          <span>{format(text, 'number_0_0')}</span>
        </Space>)
      },
    });
    _columns.push( {
      title: '较对比日',
      dataIndex: 'flow_item_detail_view_uv' + '_ratio',
      formatter: TableFormatterTag,
    });
    _columns.push({
      title: '成交子单量',
      dataIndex: 'ge_deal_standard_deal_sub_ord_qtty',
      render: (text: any) => {
        return (<Space>
          <span>成交子单量</span>
          <span>{format(text, 'number_0_0')}</span>
        </Space>)
      },
    });
    _columns.push( {
      title: '较对比日',
      dataIndex: 'ge_deal_standard_deal_sub_ord_qtty' + '_ratio',
      formatter: TableFormatterTag,
    });

    return _columns
  },[conditions])
  // const selectItem = allItem?.get(indexValue) ?? {}

  const selectItem = useMemo(()=>{
    if(_.isEmpty(allItem)) return {}
    return allItem?.get(indexValue) ?? {}
  }, [indexValue, allItem])

  function getChildColumns(index: string) {

    if(index === 'flow_source_to_item_deal_ord_amt'){
      return [
        {
          align: 'center',
          dataIndex: 'order',
          title: `${selectItem?.type === 1 ? '上升' : '下降'}排序`,
          topNum: 5,
          formatter: TableFormatterRank,
          // affix: true,
          width: 120,
        },
        {
          dataIndex: 'last_src_channel_name_1',
          title: '一级渠道',
          width: 120,
        },
        {
          dataIndex: 'last_src_channel_name_2',
          title: '二级渠道',
          width: 160,
        },
        {
          dataIndex: 'last_src_channel_name_3',
          title: '三级渠道',
          width: 160,
        },
        {
          title: `${selectItem?.type === 1 ? '上升' : '下降'}占比`,
          dataIndex: 'diaIndexRatio',
          render: (record: any) => format(record, 'percent_2_0_1'),
          width: 100,
        },
        {
          title: `${selectItem?.type === 1 ? '上升' : '下降'}金额`,
          dataIndex: 'trendValue',
          render: (record: any) => format(record, 'currency_¥'),
          width: 120,
        },
        {
          title: '成交金额',
          dataIndex: 'flow_source_to_item_deal_ord_amt',
          render: (record: any) => format(record, 'currency_¥'),
          width: 120,
        },
        {
          title: '较对比日',
          dataIndex: 'flow_source_to_item_deal_ord_amt_ratio',
          formatter: TableFormatterTag,
          width: 120,
        }
      ]

    }else if(index === 'flow_source_to_item_uv'){
      return [
        {
          align: 'center',
          dataIndex: 'order',
          title: `${selectItem?.type === 1 ? '上升' : '下降'}排序`,
          topNum: 5,
          formatter: TableFormatterRank,
          // affix: true,
          width: 120,
        },
        {
          dataIndex: 'last_src_channel_name_1',
          title: '一级渠道',
          width: 120,
        },
        {
          dataIndex: 'last_src_channel_name_2',
          title: '二级渠道',
          width: 160,
        },
        {
          dataIndex: 'last_src_channel_name_3',
          title: '三级渠道',
          width: 160,
        },
        {
          title: `${selectItem?.type === 1 ? '上升' : '下降'}占比`,
          dataIndex: 'diaIndexRatio',
          render: (record: any) => format(record, 'percent_2_0_1'),
          width: 100,
        },
        {
          title: `${selectItem?.type === 1 ? '上升' : '下降'}UV`,
          dataIndex: 'trendValue',
          render: (record: any) => format(record, 'number_0_0'),
          width: 120,
        },
        {
          title: '商详UV',
          dataIndex: 'flow_source_to_item_uv',
          render: (record: any) => format(record, 'number_0_0'),
          width: 120,
        },
        {
          title: '较对比日',
          dataIndex: 'flow_source_to_item_uv_ratio',
          formatter: TableFormatterTag,
          width: 120,
        }
      ]

    }else if(index === 'flow_source_to_item_detail_deal_sub_ord_qtty'){
      return [
        {
          align: 'center',
          dataIndex: 'order',
          title: `${selectItem?.type === 1 ? '上升' : '下降'}排序`,
          topNum: 5,
          formatter: TableFormatterRank,
          // affix: true
          width: 120,
        },
        {
          dataIndex: 'last_src_channel_name_1',
          title: '一级渠道',
          width: 120,
        },
        {
          dataIndex: 'last_src_channel_name_2',
          title: '二级渠道',
          width: 160,
        },
        {
          dataIndex: 'last_src_channel_name_3',
          title: '三级渠道',
          width: 160,
        },
        {
          title: `${selectItem?.type === 1 ? '上升' : '下降'}占比`,
          dataIndex: 'diaIndexRatio',
          render: (record: any) => format(record, 'percent_2_0_1'),
          width: 100,
        },
        {
          title: `${selectItem?.type === 1 ? '上升' : '下降'}子单量`,
          dataIndex: 'trendValue',
          render: (record: any) => format(record, 'number_0_0'),
          width: 120,
        },
        {
          title: '成交子单量',
          dataIndex: 'flow_source_to_item_detail_deal_sub_ord_qtty',
          render: (record: any) => format(record, 'number_0_0'),
          width: 120,
        },
        {
          title: '较对比日',
          dataIndex: 'flow_source_to_item_detail_deal_sub_ord_qtty_ratio',
          formatter: TableFormatterTag,
          width: 120,
        }
      ]
    }
  }

  function handleIndexChange(val:string){
    const result = allItem.get(val);
    const type = result?.type == 1 ? '增长' :  result?.type == -1 ? '下降' : result?.type == 0 ? '保持' : '空'//    type: 0, //1 增长,0保持, -1下降,
    const skuId = handledDataSource?.[0]?.sku_id
    props.handleCustomLog && props.handleCustomLog(['yx_center', 'SKUDiagnosticMetricsSelect', `{"metric":"${result?.name}","trend":"${type}","skuid":"${skuId}"}`]);
    setIndexValue(val);
    // setSelItem(indexObj.get(val))
  }
  const handledSubDataSource = useMemo(() => {
    return showMore? subDataSource.slice(0, 50) : subDataSource.slice(0, 10);
  }, [showMore, subDataSource]);

  function handleChannelChange(val:any){
    setSelChannel(val ?? null)
    const skuId = handledDataSource?.[0]?.sku_id;
    const level = val?.length;
    const valName = val?.join('-');
    props.handleCustomLog && props.handleCustomLog(['yx_center', 'SKUDiagnosticSourceRange', `{"level":"${level}", "name":"${valName}", "sku":"${skuId}"}`]);

  }

  function handleDownload(){
    const p = _.cloneDeep(tableQuery);
    const { criteria } = p;
    if (p.itemType == '2') {
      p.modelId = modelId;
      p.topSku = drawerItem.spu_id;
      p.criteria = {
        ...criteria,
        spu_id: [drawerItem.spu_id]
      }
    } else {
      p.modelId = modelId;
      p.topSku = drawerItem.sku_id
      p.criteria = {
        ...criteria,
        sku_id: [drawerItem.sku_id]
      }
    }

    if(Array.isArray(selChannel)) {
      // @ts-ignore
      if (selChannel?.length === 1) {
        p.criteria.last_src_channel_id_1 = selChannel[0]
      } else { // @ts-ignore
        if (selChannel?.length === 2) {
          p.criteria.last_src_channel_id_2 = selChannel[1]
        }
      }
    }
    const item = allItem.get(indexValue);
    p.diaIndex = indexValue;
    p.trend = item?.type === 1 ? 1 : -1;
    p.indicators = [
      "flow_source_to_item_deal_ord_amt",
      "flow_source_to_item_detail_deal_sub_ord_qtty",
      "flow_source_to_item_uv"
    ]; //诊断固定查三个指标
    p.token = '0ee9dfae-b8aa-421a-a6ab-737d2cb2b957';
    //重置继承的分页
    p.pageNo = 1;
    p.pageSize = 10;

    apis
      .downloadDiagnoseInfos(p)
      .then((res) => {
        const { ret, msg } = res;
        if (ret !== '0') throw msg || '导出失败，请稍后重试';
        message.success('导出成功，稍后将会用鲸盘分享给您');
      })
      .catch((ex) => {
        message.error(ex);
      });
  }

  function handleClickTips(){
    setIsShowTips(true);
    window.localStorage.setItem(
      `__${props.erp}__handleClickTips__`,
      'true'
    )
  }

  function handleClickMore(){
    !showMore && props.handleLog && props.handleLog('1')
    setShowMore(!showMore);
  }

  // @ts-ignore
  return (
    <React.Fragment>
      <Drawer
        width={1118}
        closable
        maskClosable
        onClose={()=>(setAllItem(null), props.setDrawerVisible(false), setDrawerVisible(false))}
        open={drawerVisible}
        placement={'right'}
      >
        <DrawerSection>
          <div className='drawer-table'>
            <div className='drawer-table-header-con'>
              <div className='drawer-table-header-title-con'>
                <div className='drawer-table-header-title'>商品诊断</div>
                <Label className='drawer-table-header-sub-title'>
                  货盘：&nbsp;{selObj?.skuName}&nbsp;&nbsp;&nbsp;平台：&nbsp;{planList.length > 0 ? planList.join() : '全部平台'}&nbsp;&nbsp;&nbsp;销售场维度：&nbsp;{placeName}
                </Label>
              </div>
              <div className='drawer-table-header-time'>
                时间：&nbsp;{formatDate(new Date(beginDate), 'YYYY/MM/DD')}-{formatDate(new Date(endDate), 'YYYY/MM/DD')}&nbsp;&nbsp;&nbsp;对比时间：&nbsp;{formatDate(new Date(cBeginDate), 'YYYY/MM/DD')}-{formatDate(new Date(cEndDate), 'YYYY/MM/DD')}
              </div>
            </div>
            <div className='rawer-table-tips-con' style={{display: closedTips ? 'none' : 'block'}}>
              <Alert className='rawer-table-tips' title='本页面帮您依据关注的指标，快速定位该商品需重点关注的渠道，助力调优~' showIcon={false}
                     closable
                     closed={closedTips}
                     onClose={() => handleClickTips()}
              />
            </div>
            <Loading loading={tableData.loading}>
              {
                handledDataSource?.length > 0 &&
                <div className='main-table'>
                  <Table key={`${JSON.stringify(tableData.bos)}${JSON.stringify(conditions)}`}
                         columns={getColumns}
                         noHeader
                         dataSource={handledDataSource}
                  />
                </div>
              }
              <div className='drawer-table-sub-con'>
                <div className='drawer-table-sub-title'>诊断详情</div>
                <div className='drawer-table-index-con'>
                  <Form inline>
                    <FormItem label='选择诊断主指标'>
                      <RadioGroup
                        value={indexValue}
                        onChange={((val:any)=>{handleIndexChange(val)})}
                        size='small'
                        data={indexData}
                      />
                    </FormItem>
                    {
                      channel?.length > 0 &&
                      <FormItem label='筛选来源渠道' >
                        <Select
                          key={JSON.stringify(channel)}
                          render={Cascader}
                          data={channel}
                          value={selChannel}
                          onChange={((val:any)=>{handleChannelChange(val)})}
                          width={200}
                          allowClear
                          size='small'
                          placeholder={'请选择来源渠道'}
                        />
                      </FormItem>
                    }
                  </Form>
                </div>
              </div>
              <div className={`drawer-table-context ${(selectItem?.type == null || selectItem?.type === 0) ? 'drawer-table-context-empty' : ''}`}>
                <div className='drawer-table-context-icon'></div>
                { selectItem?.type === 1 && <Label className='drawer-table-context-text'>该货品【{selectItem?.name}】在该时段内呈【上升】趋势，要继续保持哦</Label> }
                {
                  selectItem?.type === 0 &&
                  <>
                    <Label className='drawer-table-context-text'>该货品【{selectItem?.name}】在该时段内</Label>
                    <Label className='drawer-table-context-main-text'>同比持平  要稳中求进哦</Label>
                  </>
                }
                {
                  selectItem?.type == null &&
                  <>
                    <Label className='drawer-table-context-none-text'>该货品【{selectItem?.name}】在对比时间内暂无数据，不支持诊断。可点击上方“选择诊断主指标”进行指标切换以查看诊断结果</Label>
                    {/*<Label className='drawer-table-context-text'>暂无数据，不支持诊断。可点击上方“选择诊断主指标”进行指标切换以查看诊断结果</Label>*/}
                  </>
                }
                {selectItem?.type === -1 && <Label className='drawer-table-context-text'>该货品【{selectItem?.name}】在该时段内呈【下降】趋势，请重点关注</Label>}
                {selectItem?.type != 0 && selectItem?.type != null &&
                <div className='drawer-table-context-items'>
                  <div className='drawer-table-context-item'>
                    <div className='drawer-table-context-title'>同比{selectItem?.type === 1 ? '上升' : '下降'}</div>
                    <div className='drawer-table-context-number'>
                      {format(selectItem?.ratio, getJmtdValFormatter(2))}
                      {selectItem?.type === 1 && <Icon style={{color: '#1EC337'}} className='jmti-arrow-up'/>}
                      {selectItem?.type === -1 && <Icon style={{color: '#FF4C4C'}} className='jmti-arrow-down'/>}
                    </div>
                  </div>
                  <div className='drawer-table-context-item'>
                    <div className='drawer-table-context-title'>{selectItem?.type === 1 ? '上升' : '下降'}{selectItem?.showName}</div>
                    <div className='drawer-table-context-number'>{format(selectItem?.diff, getJmtdValFormatter(selectItem?.valueType))}</div>
                  </div>
                  <div className='drawer-table-context-item'>
                    {topSku.loading &&  <div className='drawer-table-context-title'>{selectItem?.type === 1 ? '上升' : '下降'}排位计算中...</div>}
                    {topSku.loading &&  <div className='drawer-table-context-index'>第&nbsp;<span>?</span>&nbsp;位</div>}
                    {!topSku.loading &&  <div className='drawer-table-context-title'>{selectItem?.type === 1 ? '上升' : '下降'}{selectItem?.showName}排位</div>}
                    {!topSku.loading &&  <div className='drawer-table-context-index'>第&nbsp;<span>{topSku.value}</span>&nbsp;位</div>}
                  </div>
                </div>
              }

              </div>
              {
                selectItem?.type != null && selectItem?.type != 0 &&
                <div className='sub-table'>
                  {
                    subDataSource?.length === 0 && (_.isEmpty(selectItem?.ratio) || _.isEmpty(selectItem?.valueType)) && selectItem?.type != null &&
                    <div className='sub-table-empty'>
                      <Empty description="在对比时段内，该指标在各细分渠道下没有数据（或为0），因此没有进行升、降幅的计算" />
                    </div>

                  }
                  {
                    subDataSource?.length > 0 &&
                    <Table key={`${JSON.stringify(subTableData.bos)}${JSON.stringify(conditions)}${showMore}`}
                           columns={getChildColumns(indexValue)}
                           dataSource={handledSubDataSource}
                           scrollY={355}
                           id='subTable'
                    />
                  }
                  {
                    subTableData.total > 10 &&
                    <div className='show-more' onClick={()=>{handleClickMore()}}>{showMore? <Label>收起<Icon className={`${showMore ? 'jmti-angle-up' : 'jmti-angle-down'}`}/></Label> : <Label clsTag={'h|keycount|yx_center_hzcp_1680082497624|1'}>查看更多<Icon className={`${showMore ? 'jmti-angle-up' : 'jmti-angle-down'}`}/></Label>}</div>
                  }
                </div>
              }
            </Loading>

            <div className='drawer-table-bottom-empty'></div>
            <div className='drawer-table-bottom'>
              <Space size='large'>
                {
                  !tableData.loading && subDataSource?.length > 0 &&
                  <Button onClick={()=>{handleDownload()}} clsTag={'h|keycount|yx_center_hzcp_1680082497624|2'}>导出数据</Button>
                }

                <Button semantic='primary' onClick={()=>(props.setDrawerVisible(false), setDrawerVisible(false))}>关闭</Button></Space>
            </div>

          </div>

        </DrawerSection>
      </Drawer>
      {/*<DownLoadModal visible={modalVisible} setVisible={setModalVisible} conditions={conditions} item={downloadItem} downloadBySku={true} skuGroupId={props.skuGroupId} selObj={props.selObj}/>*/}
    </React.Fragment>

  );
}

export default DrawerTable;